import $ from 'jquery'

export default {
    name: 'manage-duree-bon',
    components: {},
    props: {
        liste_consultations: Array, 
        state_toggler: Number
    },
    data() {
        return {
            select_all: '',
            all_checked: false,
            one_is_checked: [],
            text_grey: [],
            save_loading: false,
            duree_bon: "",
            choice_is_empty: false,
            error_message: '',
            unite_duree: 'jours'
        }
    },

    watch: {
        state_toggler() {
            this.one_is_checked = []
            this.all_checked = false
            this.text_grey = []
            this.choice_is_empty = false
            this.duree_bon = ""
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.liste_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.liste_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            this.choice_is_empty = false
            let is_checked = $('#consult'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
            document.getElementById("consult-tous").checked = false;
        },

        async submit() {
            const isValid = await this.$refs.duree_form.validate();
            if (!isValid) {
                return;
            }

            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }

            let data = {
                unite_duree: this.unite_duree,
                duree_bon: parseInt(this.duree_bon),
                type_consultations: this.one_is_checked, 
            }

            this.save_loading = true
            this.$store.dispatch('saveDureeBonConsultations', data).then((response) => {
                if (response.success) {
                    this.$refs.config_duree_bon.click()
                    this.$emit('emitDureeBon')
                    this.successToast("Durée de bon de consultations définie avec succès")
                } else {
                    if (response.code == 400) {
                        this.error_message = response.msg
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.$refs.config_duree_bon.click()
                this.errorToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        }   

    }
}